import React, { useState } from 'react'
import { useEffect } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { ReactComponent as Seperator } from '../../assets/icons/ui/RightArrow.svg'

let displayName
const inventoryHome = "Streetlight Home"
const invAcct = "InventoryAccount"
const invRefInfo = "InventoryReferenceInfo"
const invReport = "InventoryReport"
const accountList = "Account List"
const refNumbers = "Reference Numbers"
const inventoryReport = "Inventory Report"

const streetHome = "Streetlight Home"
const outageWarning = "OutageWarning"
const outageMap = "OutageMap"
const OutageWarning = "Outage Warning"
const OutageReporting = "Outage Reporting"
const directory = "Contacts"
const Directory = "StreetLights Directory"

const changeDisplayName = (name) => {
  switch (name) {
  case invAcct:
    displayName = accountList
    break
  case invRefInfo:
    displayName = refNumbers
    break
  case invReport:
    displayName = inventoryReport
    break
  case outageWarning:
    displayName = OutageWarning
    break
  case outageMap:
    displayName = OutageReporting
    break
  case directory:
    displayName = Directory
    break 
  default:
    displayName = ""
  }
}

const Breadcrumbs = (props) => {
  const [ isShowBreadcrumbs, setIsShowBreadcrumbs ] = useState(false)
  const [ homeName, setHomeName ] = useState('')
  const { history, location: { pathname } } = props
  const pathNames = pathname.split("/").filter(x => x)

  useEffect(() => {
    if (pathNames[0] === invAcct) {
      setIsShowBreadcrumbs(true)
      setHomeName(inventoryHome)
    } else if (pathNames[0] === outageWarning) {
      setIsShowBreadcrumbs(true)
      setHomeName(streetHome)
    } else {
      setIsShowBreadcrumbs(false)
    }
  }, [pathNames])

  return (
    <>
      {isShowBreadcrumbs ?
        <div className="bread-crumbs" >
          <Link className="bread-link" to="/"><p>{homeName}</p></Link>
          <Seperator className="bread-icon" />

          {pathNames.map((name, index) => {
            const routeTo = `/${pathNames.slice(0, index + 1).join("/")}`
            const isLast = index === pathNames.length - 1
            changeDisplayName(name)

            return isLast ? (
              <div className="bread-last" key={index}>
                <p>{displayName}</p>
              </div>
            ) : [
              <Link to={routeTo} className="bread-link" key={index} 
                onClick= {() => {history.push({pathname: routeTo }) }}>
                <p>{displayName}</p>
              </Link>,
              <Seperator className="bread-icon" key={name} />,
            ]
          })}
        </div>
        : null
      }
    </>
  )
}

export default withRouter(Breadcrumbs)